import React from "react"

import { withRouter } from "react-router-dom"
import { connect } from "react-redux"
import querystring from "querystring"
import i18n from "../i18n/i18n"
import { setRefer, setSharedResult, setLang } from "../store/general"

class Initialization extends React.Component {
  componentDidMount() {
    const { dispatch, history } = this.props
    const params = querystring.parse(window.location.search.substring(1))

    /*********************/
    /* Parameter Setting */
    /*********************/

    // 언어 parameter가 있는 경우
    if (params["lang"]) {
      // html 태그의 'lang' property를 변경
      document.documentElement.lang = params["lang"]

      i18n.changeLanguage(params["lang"])
      dispatch(setLang(params["lang"]))
    }

    // 유입 경로 parameter가 있는 경우
    if (params["r"]) dispatch(setRefer(params["r"]))

    // sr parameter : '내 결과 공유하기'로 들어온 경우
    if (params["sr"]) {
      dispatch(setSharedResult(params["sr"]))
      history.push("/result")
    }
  }

  render() {
    return <></>
  }
}
const mapStateToProps = (state) => ({})

export default withRouter(connect(mapStateToProps)(Initialization))
